import { Directive, effect, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[ttDiff]',
  standalone: true,
})
export class DifferenceDirective {
  private readonly element = inject(ElementRef);

  public ttDiff = input.required<string>();

  public highlight = input('difference');

  private readonly allTextNodes = [] as Node[];

  private setHighlight = effect(() => {
    const search = this.ttDiff();

    const text = this.element.nativeElement.textContent.trim();
    const firstCharacter = this.element.nativeElement.textContent.indexOf(/\S/);
    const ranges: Range[] = [];
    let startPos: number | undefined;

    for (const [index, char] of text.split('').entries()) {
      if (char === search[index]) {
        if (text[index - 1] !== search[index - 1] && startPos !== undefined) {
          ranges.push(this.createRange(startPos, index, firstCharacter));
        }
        continue;
      }
      startPos = index;
    }
    if (text[text.length - 1] !== search[text.length - 1] && startPos !== undefined) {
      ranges.push(this.createRange(startPos, search.length, firstCharacter));
    }

    //eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!CSS.highlights) {
      ranges
        .slice()
        .reverse()
        .forEach((range) => {
          const span = document.createElement('span');
          span.className = this.highlight();
          range.surroundContents(span);
        });
      return;
    }
    CSS.highlights.set(this.highlight(), new Highlight(...ranges.flat()));
  });

  private createRange(start: number, end: number, offset: number = 0) {
    const range = new Range();
    range.setStart(this.element.nativeElement.firstChild, start - offset);
    range.setEnd(this.element.nativeElement.firstChild, end - offset);
    return range;
  }
}
